import { getClientId } from '../utils/guid';

export const API_URL = process.env.REACT_APP_API_URL;
export const AUTHORIZATION_TOKEN = 'eWNRaThYRTg6N2l5SGVSdzREaTdKb3J2R05GR2k2UWxLSWczQlh2ME4=';
export const STORAGE_OAUTH_KEY = 'DictateIT.Client.OAuth';
export const SP_RETURN_PATH = 'Secretary-Portal-return-path';
export const CLIENT_ID = getClientId();
